import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const RemoveShoppingcartIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.73 22.73L2.77 2.77L2 2L1.27 1.27L0 2.54L4.39 6.93L6.6 11.59L5.25 14.04C5.09 14.32 5 14.65 5 15C5 16.1 5.9 17 7 17H14.46L15.84 18.38C15.34 18.74 15.01 19.33 15.01 20C15.01 21.1 15.9 22 17 22C17.67 22 18.26 21.67 18.62 21.16L21.46 24L22.73 22.73ZM7.42 15C7.28 15 7.17 14.89 7.17 14.75L7.2 14.63L8.1 13H10.46L12.46 15H7.42ZM15.55 13C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C20.96 5.34 21 5.17 21 5C21 4.45 20.55 4 20 4H6.54L15.55 13ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  },
)
